import React from "react";
import Layout from "../component/Layout";
import PasswordResetForm from "../component/forms/PasswordResetForm";

const PasswordReset = () => {
  return (
    <>
      <div className="login-register-page-wrapper section-gap bg-color-white">
        <div className="container checkout-page-style">
          <div className="row g-5 text-center">
            <div className="col-lg-3"></div>
            <div className="col-lg-6">
              <PasswordResetForm />
            </div>
            <div className="col-lg-3"></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PasswordReset;
